export default __webpack_public_path__ + "static/media/radiant-bright-green-yellow.4849812a.jpg";